import { render, staticRenderFns } from "./AllegatiModuli.vue?vue&type=template&id=916cf048&"
import script from "./AllegatiModuli.vue?vue&type=script&lang=js&"
export * from "./AllegatiModuli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports